// The chosen-brand-direction handoff between `/apps/new/brand` and
// `/apps/new/brand/mockups` (Flow 3). No landed GET reads back "the currently chosen
// direction" (`packages/shared/src/http/validate.ts` VALIDATE_ROUTES has no such route)
// - this mirrors `src/state/wizard.tsx`'s own `sessionStorage`-backed resumability
// pattern (STORAGE_KEY/readStoredAppId) rather than inventing a fetch, scoped to this
// feature's own module so it never touches the shared wizard state.
const STORAGE_KEY = "nightcrew.build.brandDirectionId";

export const setStoredBrandDirectionId = (id: string): void => {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, id);
};

export const getStoredBrandDirectionId = (): string | null => {
  if (typeof sessionStorage === "undefined") return null;
  const value = sessionStorage.getItem(STORAGE_KEY);
  return value === null || value.length === 0 ? null : value;
};
